define(
    'Tavano.GoogleFix.GoogleFix'
    , [
        'Tavano.GoogleFix.GoogleFix.View'
    ]
    , function (
        GoogleFixView
    ) {
        'use strict';

    });
